import * as React from 'react'
import { FormGroup, HTMLSelect, Button, Intent } from '@blueprintjs/core'
import Client from '../../../client'
import Spinner from '../../Spinner'
import APIErrorCallout from '../../../components/errors/APIErrorCallout'

interface ListingStrategy {
  id: number
  name: string
  organizationId: number
  autoPurge: boolean
  categoryIds: number[]
  steps: Step[]
  activeListingsCount: number
}

interface Step {
  id: number
  listingStrategyId: number
  rank: number
  delay: number
  configurations: Configuration[]
}

interface Configuration {
  id: number
  listingStrategyStepId: number
  listingType: null | string
  listingDuration: null | string
  priceChangeBy: null | string
  priceChange: null | string
  shippingPriceChangeBy: null | string
  shippingPriceChange: null | string
  reservePriceChangeBy: null | string
  reservePriceChange: null | string
  buyItNowPriceChangeBy: null | string
  buyItNowPriceChange: null | string
  scheduleTime: null | string
  market: Market
}

interface Market {
  id: number
  name: string
  humanReadableName: string
}

export interface ListingStrategyChangeDialogProps {
  listingStrategyId: number
  productId: number
  onClose: Function
  onChange: Function
}

export interface ListingStrategyChangeDialogState {
  loading: boolean
  error: any
  data: ListingStrategy[]
  listingStrategyId: number
}

class ListingStrategyChangeDialog extends React.Component<
  ListingStrategyChangeDialogProps,
  ListingStrategyChangeDialogState
> {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: null,
      listingStrategyId: props.listingStrategyId,
      data: []
    }
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData = async () => {
    try {
      const res = await Client.getListingStrategies({ sort: 'name.asc' })
      this.setState({
        loading: false,
        data: res.data.listingStrategies
      })
    } catch (error) {}
  }

  onSave = async () => {
    try {
      await Client.updateProductListingStrategy(this.props.productId, {
        id: this.state.listingStrategyId
      })
      this.setState({
        loading: false
      })
      this.props.onClose()
      this.props.onChange()
    } catch (error) {
      this.setState({ loading: false, error: error.response })
    }
  }

  render() {
    const { loading } = this.state

    if (loading) {
      return (
        <div className="bp3-dialog-body">
          <Spinner />
        </div>
      )
    }

    return (
      <>
        {this.state.error && <APIErrorCallout response={this.state.error} />}
        <div className="bp3-dialog-body">
          <FormGroup label="Choose Strategy">
            <HTMLSelect
              onChange={e =>
                this.setState({
                  listingStrategyId: e.target.value ? parseInt(e.target.value) : null
                })
              }
              style={{ minWidth: 225 }}
              value={this.state.listingStrategyId}
              options={this.state.data.map(l => ({ label: l.name, value: l.id }))}
            />
          </FormGroup>
        </div>
        <div className="bp3-dialog-footer">
          <div className="bp3-dialog-footer-actions">
            <Button loading={loading} intent={Intent.NONE} onClick={() => this.props.onClose()}>
              Cancel
            </Button>
            <Button
              loading={loading}
              intent={Intent.PRIMARY}
              disabled={!this.state.listingStrategyId}
              onClick={this.onSave}
            >
              Save
            </Button>
          </div>
        </div>
      </>
    )
  }
}

export default ListingStrategyChangeDialog
